import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const OwnerContactCard = ({ owner, pickup, onContact }) => {
  return (
    <div className="bg-card rounded-lg shadow-elevation-3 p-6">
      <div className="flex items-center space-x-3 mb-6">
        <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
          <Icon name="User" size={20} color="var(--color-primary)" strokeWidth={2} />
        </div>
        <h2 className="font-heading text-2xl font-semibold text-foreground">
          Owner Contact
        </h2>
      </div>

      {/* Owner Profile */}
      <div className="flex items-start space-x-4 mb-6">
        <div className="relative">
          <div className="w-16 h-16 rounded-full overflow-hidden">
            <img
              src={owner?.avatar}
              alt={owner?.avatarAlt}
              className="w-full h-full object-cover"
            />
          </div>
          {owner?.verified && (
            <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-success rounded-full flex items-center justify-center border-2 border-card">
              <Icon name="CheckCircle2" size={12} color="white" strokeWidth={2.5} />
            </div>
          )}
        </div>

        <div className="flex-1">
          <div className="flex items-center space-x-2 mb-1">
            <h3 className="font-heading text-lg font-semibold text-foreground">
              {owner?.name}
            </h3>
            {owner?.verified && (
              <span className="px-2 py-0.5 bg-success/10 text-success text-xs font-caption font-medium rounded">
                Verified
              </span>
            )}
          </div>

          <div className="flex items-center space-x-1 mb-2">
            <Icon name="Star" size={14} color="var(--color-accent)" strokeWidth={2} fill="var(--color-accent)" />
            <span className="font-body text-sm font-semibold text-foreground">
              {owner?.rating}
            </span>
            <span className="font-body text-xs text-muted-foreground">
              ({owner?.reviewCount} reviews)
            </span>
          </div>

          <div className="flex items-center space-x-2 text-muted-foreground">
            <Icon name="MapPin" size={14} strokeWidth={2} />
            <span className="font-body text-xs">{owner?.location}</span>
          </div>
        </div>
      </div>

      {/* Contact Information */}
      <div className="space-y-3 mb-6 pb-6 border-b border-border">
        <div className="flex items-center space-x-3">
          <Icon name="Phone" size={18} color="var(--color-primary)" strokeWidth={2} />
          <div>
            <p className="font-caption text-xs text-muted-foreground">Phone</p>
            <p className="font-body text-sm font-medium text-foreground">{owner?.phone}</p>
          </div>
        </div>

        <div className="flex items-center space-x-3">
          <Icon name="Mail" size={18} color="var(--color-primary)" strokeWidth={2} />
          <div>
            <p className="font-caption text-xs text-muted-foreground">Email</p>
            <p className="font-body text-sm font-medium text-foreground">{owner?.email}</p>
          </div>
        </div>

        <div className="flex items-center space-x-3">
          <Icon name="Clock" size={18} color="var(--color-primary)" strokeWidth={2} />
          <div>
            <p className="font-caption text-xs text-muted-foreground">Response Time</p>
            <p className="font-body text-sm font-medium text-foreground">{owner?.responseTime}</p>
          </div>
        </div>
      </div>

      {/* Pickup Instructions */}
      <div className="mb-6">
        <h3 className="font-heading text-base font-semibold text-foreground mb-3">
          Pickup Instructions
        </h3>
        
        <div className="space-y-3">
          <div className="flex items-start space-x-3">
            <Icon name="MapPin" size={18} color="var(--color-primary)" strokeWidth={2} />
            <div>
              <p className="font-caption text-xs text-muted-foreground mb-1">Location</p>
              <p className="font-body text-sm text-foreground">{pickup?.address}</p>
            </div>
          </div>

          <div className="flex items-start space-x-3">
            <Icon name="Clock" size={18} color="var(--color-primary)" strokeWidth={2} />
            <div>
              <p className="font-caption text-xs text-muted-foreground mb-1">Available Hours</p>
              <p className="font-body text-sm text-foreground">{pickup?.contactTime}</p>
            </div>
          </div>

          {pickup?.accessCode && (
            <div className="flex items-start space-x-3">
              <Icon name="Key" size={18} color="var(--color-primary)" strokeWidth={2} />
              <div>
                <p className="font-caption text-xs text-muted-foreground mb-1">Access Code</p>
                <p className="font-body text-sm font-semibold text-foreground">{pickup?.accessCode}</p>
              </div>
            </div>
          )}

          <div className="p-3 bg-muted rounded-md">
            <p className="font-body text-xs text-muted-foreground">
              {pickup?.instructions}
            </p>
          </div>
        </div>
      </div>

      {/* Contact Button */}
      <Button
        variant="default"
        size="lg"
        fullWidth
        iconName="MessageCircle"
        iconPosition="left"
        onClick={onContact}
      >
        Message Owner
      </Button>
    </div>
  );
};

export default OwnerContactCard;